import { useState, type FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthShell } from "../components/AuthShell";
import { Button } from "../components/Button";
import { Input } from "../components/Input";
import { signUp, authErrorMessage } from "../lib/auth";

export default function SignUp() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const result = await signUp(email, password);
      if (result.nextStep.signUpStep === "CONFIRM_SIGN_UP") {
        navigate(`/verify?email=${encodeURIComponent(email)}`, { replace: true });
      } else if (result.nextStep.signUpStep === "DONE") {
        navigate("/signin", { replace: true });
      }
    } catch (err) {
      setError(authErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Create your account"
      subtitle="Free trial — 15 days, 100 emails. No card required."
      footer={
        <>
          Already have an account?{" "}
          <Link to="/signin" className="font-medium text-gray-900 hover:underline">
            Sign in
          </Link>
        </>
      }
    >
      <form onSubmit={onSubmit} className="space-y-4">
        <Input
          name="email"
          type="email"
          label="Work email"
          autoComplete="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@company.com"
        />
        <Input
          name="password"
          type="password"
          label="Password"
          autoComplete="new-password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          hint="At least 12 characters with upper, lower, number, and symbol."
        />
        {error && (
          <div className="rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
            {error}
          </div>
        )}
        <Button type="submit" loading={loading} className="w-full" size="md">
          Create account
        </Button>
        <p className="text-xs text-gray-500">
          By signing up you agree to the Terms and Privacy Policy.
        </p>
      </form>
    </AuthShell>
  );
}
